// extracted by mini-css-extract-plugin
module.exports = {"container":"BootCapacityTextBox_container__PB2bi","firstText":"BootCapacityTextBox_firstText__Fmihc","secondText":"BootCapacityTextBox_secondText__kYS6_"};